<template>
  <div class="about">
    <v-container>
      <!-- Overview of all projects -->
      <v-row v-masonry>
        <v-col :cols="cols" v-for="info in projects_info" :key="info.title">
          <project-card
            :title="info.title"
            :text="info.text"
            :date="info.date"
            :keywords="info.keywords"
            :image="info.image"
            :link="info.url"
          />
        </v-col>
      </v-row>
    </v-container>

    <!-- Search functionality -->
    <v-menu
      :close-on-content-click="false"
      left
      nudge-left="60px"
      nudge-bottom="2px"
    >
      <template v-slot:activator="{ on: menu, attrs }">
        <v-btn
          fab
          color="primary"
          fixed
          right
          bottom
          v-bind="attrs"
          v-on="menu"
        >
          <v-icon large>mdi-magnify</v-icon>
        </v-btn>
      </template>

      <div>
        <v-text-field
          v-model="search_text"
          placeholder="Search..."
          solo
          clearable
          flat
          hide-details="auto"
        />
      </div>
    </v-menu>
  </div>
</template>

<script>
import ProjectCard from "../components/ProjectCard.vue";
import { mapGetters } from "vuex";

export default {
  name: "Projects",
  components: {
    ProjectCard,
  },
  computed: {
    ...mapGetters(["projects_info"]),
  },
  data() {
    return {
      cols: this.get_cols(window.innerWidth),
      search_text: "",
    };
  },
  mounted() {
    this.fetchData();
    window.addEventListener("resize", () => {
      this.cols = this.get_cols(window.innerWidth);
    });
  },
  methods: {
    async fetchData() {
      await this.$store.dispatch("fetchProjects");
      this.$redrawVueMasonry();
    },
    get_cols: function (width) {
      // Get the corresponding column-width for the given width
      const cols = width < 700 ? 12 : width < 1200 ? 6 : width < 1600 ? 4 : 3;
      this.$redrawVueMasonry();
      return cols;
    },
    search_projects(search_text) {
      this.$store.dispatch("search", { text: search_text });
      this.$redrawVueMasonry();
    },
  },
  watch: {
    search_text: function () {
      this.search_projects(this.search_text);
    },
  },
};
</script>

<style scoped>
.search {
  height: 80px;
  width: 200px;
  color: white !important;
  background-color: #00000000;
}
</style>
